<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Plans</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-plan @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <plans-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlansTable from '@/components/plan/Table/index'
import AddPlan from '@/components/plan/Forms/Add/index'

export default {
  components: {
    PlansTable,
    AddPlan,
  },
  mounted: function() {
    this.getPlans()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
    }
  },
  methods: {
    getPlans: function() {
      this.loading = true
      this.$http.get('/api/plan', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getPlans()
    },
    handleUpdateTable: function() {
      this.getPlans()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getPlans()
    },
    onChange(current) {
      this.current = current
      this.getPlans()
    },
  },
}
</script>
